"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const hiddenScroll = document.querySelector("body");
    const mobileButton = document.querySelector(".menu-mobile .button");
    const menu = document.querySelector(".menu-mobile");
    const close = menu.querySelector(".close-icon");

    hamburguer.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });
    close.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });

    mobileButton.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });

    const subMenus = document.querySelectorAll(
        ".menu-mobile .menu-item-has-children",
    );

    subMenus.forEach((item) => {
        const toggle = item.querySelector(".c-main-menu__toggle");
        const submenu = item.querySelector(".c-main-menu__dropdown");

        if (!toggle || !submenu) return;

        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = item.classList.contains("is-open");

            // fecha outros abertos (accordion)
            subMenus.forEach((other) => {
                if (other !== item) {
                    other.classList.remove("is-open");
                    const otherToggle = other.querySelector(
                        ".c-main-menu__toggle",
                    );
                    if (otherToggle) {
                        otherToggle.setAttribute("aria-expanded", "false");
                    }
                }
            });

            // toggle atual
            item.classList.toggle("is-open", !isOpen);
            toggle.setAttribute("aria-expanded", !isOpen ? "true" : "false");
        });
    });
}
